<template>
    <div class="col-12 text-center alert alert-info notification_box" style="margin-top: 15%">
        {{$t('add_infos')}}. &nbsp; &nbsp; <a href="#" @click="goToParams" class="ml-2">{{$t('go_to_params')}}</a>
        <!-- <v-card>
            <v-alert style="background-color: #fff" outlined border="left" type="info">{{$t('add_infos')}}</v-alert>
            <v-btn @click="goToParams"> {{$t('go_to_params')}} </v-btn>
        </v-card> -->
    </div>
</template>

<script>
    export default {
        name: "GoToParams",
        methods:{
            goToParams(){
                this.$router.push({name:'settings'})
            }
        }
    }
</script>

<style scoped>

</style>